import {type ChartInstanceProps} from './_components/ButterflyChart/types'
import {z} from 'zod'

export const LEGACY_BANK_CHART_PROPS: ChartInstanceProps = {
  label: 'Legacy bank fees',
  color: 'beige',
  category: 'legacyBank',
}

export const MERCURY_CHART_PROPS: ChartInstanceProps = {
  label: 'Mercury fees',
  color: 'primary',
  category: 'mercury',
}

export const BUTTERFLY_CHART_Y_AXIS_KEY = 'feeType'

export const bankFeeCalculatorFormSchema = z.object({
  totalTransactions: z.number().min(0).nullable(),
  achTransactions: z.number().min(0).nullable(),
  incomingDomesticWires: z.number().min(0).nullable(),
  outgoingDomesticWires: z.number().min(0).nullable(),
  incomingInternationalWires: z.number().min(0).nullable(),
  outgoingInternationalWires: z.number().min(0).nullable(),
  foreignCurrencyInternationalWires: z.number().min(0).nullable(),
})
